export default __webpack_public_path__ + "static/pitch-bg-eb18a25f2ec9a3d98b6d2ffd2a3cb829.svg";